<template>
  <customize-header class="page-invite-experience-vip">
    <top-bar slot="header"
             show-header
             :title="render.pageTitle"
    >
      <template #header-right>
        <router-link class="page-invite-experience-vip-header-right"
                     :to="{ name: 'MyVipCenter' }"
        >
          进入会员中心
        </router-link>
      </template>
    </top-bar>

    <bottom-bar-layout :show-bar="poster.length > 0"
                       :bar-height="160"
                       bar-background="transparent"
                       :show-consult="false"
    >
      <div class="page-invite-experience-vip-content">
        <invite-rule v-if="showRule"
                     :rule="rule"
        />

        <div v-if="showCount"
             class="page-invite-experience-vip-count"
        >
          <div class="page-invite-experience-vip-count-item">
          <span class="page-invite-experience-vip-count-num">
            {{ count.invitedExperiencers }}</span>人
            <br />
            累计邀请好友
          </div>
          <div class="page-invite-experience-vip-count-item">
          <span class="page-invite-experience-vip-count-num">
            {{ count.extendedDays }}</span>天
            <br />
            累计延长天数
          </div>
        </div>

        <div v-if="currentPoster"
             class="page-invite-experience-vip-current-poster"
        >
          <ym-img class="page-invite-experience-vip-current-poster-img"
                  :class="{ 'show-count': showCount }"
                  :src="currentPoster.bg"
                  :alt="`${currentPoster.type}海报`"
          />
          <div class="page-invite-experience-vip-hint">
            长按保存海报，邀请好友加入
          </div>
        </div>
      </div>

      <template #tabbar>
        <div class="page-invite-experience-vip-bottom-bar">
          <div class="page-invite-experience-vip-poster-thumb"
               v-for="item in poster"
               :key="item.type"
               @click="handleClickPosterThumb(item)"
          >
            <ym-img class="page-invite-experience-vip-poster-thumb-img"
                    :src="item.bg"
                    :alt="`${item.type}海报缩略图`"
            />
            <div v-if="item.checked"
                 class="page-invite-experience-vip-poster-thumb-checked"
            >
              <ym-icon class="page-invite-experience-vip-poster-thumb-icon"
                       name="round-check-plain"
              />
            </div>
          </div>
        </div>
      </template>
    </bottom-bar-layout>
  </customize-header>
</template>

<script>
  import { Icon } from '@ymba/ym-ui';
  import CustomizeHeader from '@/layout/CustomizeHeaderLayout';
  import TopBar from '@/components/TopBar';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import InviteRule from '@/pages/MyVip/components/InviteExperienceRule';
  import { locationHref, isWeiXinBrowser } from '@/utils';
  import { inviteExperienceVip } from '@/services/vip';
  import { getWeChatUserInfo } from '@/services/app';

  export default {
    name: 'MyVipInviteExperience',
    metaInfo: {},
    components: {
      CustomizeHeader,
      TopBar,
      BottomBarLayout,
      InviteRule,
      'ym-icon': Icon,
    },
    data() {
      return {
        showRecordPopup: false,
        showRulePopup: false,
        count: {
          invitedExperiencers: 0,
          extendedDays: 0,
        },
        qrCode: {
          link: '',
          name: '',
        },
        poster: [],
        currentPoster: null,
        record: [],
        rule: '',
        render: {
          pageTitle: '',
          hasWechatAuth: false,
        },
      };
    },
    computed: {
      showCount() {
        const { count } = this;
        if (count == null) return false;
        const { invitedExperiencers, extendedDays } = count;
        return invitedExperiencers > 0 || extendedDays > 0;
      },
      showRule() {
        return this.rule && this.rule !== '';
      },
    },
    methods: {
      autoClickPoster() {
        const { poster } = this;
        const current = poster[0];
        if (current == null) return;
        current.checked = true;
        this.currentPoster = current;
      },
      async getWeChatUserInfo() {
        const data = await getWeChatUserInfo(this.$route.fullPath);
        locationHref(data);
      },
      async fetchData(id) {
        const data = await inviteExperienceVip(id);
        // 在微信且无授权，则请求授权
        if (isWeiXinBrowser() && !data.render.hasWechatAuth) {
          this.getWeChatUserInfo();
          return;
        }

        this.count = data.count;
        this.poster = data.poster;
        this.record = data.record;
        this.rule = data.rule;
        this.render = data.render;

        this.autoClickPoster();
      },
      handleClickPosterThumb(thumb) {
        const { checked, type } = thumb;
        if (checked) return;
        const prev = this.poster.find(item => item.checked);
        prev.checked = false;
        const current = this.poster.find(item => item.type === type);
        current.checked = true;
        this.currentPoster = current;
      },
    },
    created() {
      const { $route: { id } } = this;
      this.fetchData(id);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-invite-experience-vip {
    position: relative;
    background: @color-white;

    &-header-right {
      font-size: @font-size-base;
      color: @color-text-light;
    }

    /deep/ .ym-header-back-btn {
      width: 162px;
      margin-left: 0;
    }

    /deep/ .ym-tabbar {
      box-shadow: 0 -5px 10px 0 rgba(51, 51, 51, 0.05);
      border-radius: @border-radius-medium @border-radius-medium 0 0;
    }

    &-content {
      padding: @size-base (@size-medium + @size-extra-small/2);
    }

    &-count {
      display: flex;
      margin-bottom: @size-base;
      align-items: center;
      justify-content: center;
      font-size: @font-size-small;
      color: @color-text-light;
      background: @background-color-lighter;
      border-radius: @border-radius-medium;

      &-item {
        flex: 1;
        text-align: center;
        padding: @size-small 0;
      }

      &-num {
        font-size: 56px;
        color: @color-text-primary;
      }
    }

    &-current-poster {
      text-align: center;

      &-img {
        display: block;
        width: 550px;
        height: 825px;
        overflow: hidden;
        margin: @size-extra-small auto @size-small;
        border-radius: 10px;
        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);

        &.show-count {
          width: 500px;
          height: 750px;
        }
      }
    }

    &-hint {
      font-size: @font-size-medium;
    }

    &-bottom-bar {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      background: @color-white;
    }

    @poster-thumb-size: 100px;
    &-poster-thumb {
      position: relative;
      width: @poster-thumb-size;
      height: @poster-thumb-size;
      overflow: hidden;
      margin: 0 @size-base/2;
      border-radius: @border-radius-normal;

      &-checked {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        background: rgba(0, 0, 0, .5);
        border-radius: inherit;
      }

      &-icon {
        font-size: 50px;
      }
    }
  }
</style>
